import AudioPlayer, {RHAP_UI} from "react-h5-audio-player";
import 'react-h5-audio-player/lib/styles.css';
import {MIN_DESKTOP_SIZE} from "../../constants/global";

export default function SimpleAudioPlayer({...otherProps}) {
    return (
        <AudioPlayer
            customControlsSection={[
                window.screen.width >= MIN_DESKTOP_SIZE ? RHAP_UI.VOLUME_CONTROLS : null
            ]}
            customProgressBarSection={[
                RHAP_UI.MAIN_CONTROLS,
                window.screen.width >= MIN_DESKTOP_SIZE ? RHAP_UI.PROGRESS_BAR : null,
            ]}
            layout="horizontal"
            preload="none"
            customAdditionalControls={[]}
            customIcons={{
                play: <i className="icon-play text-base text-pol-purple mr-[0.313rem] xl:mr-0" />,
                pause: <i className="icon-circle-pause text-base text-pol-purple mr-1 xl:mr-0" />,
                volume: <i className="icon-speaker text-base text-pol-purple" />,
                volumeMute: <i className="icon-times-speaker text-base text-pol-purple" />,
            }}
            defaultCurrentTime=""
            defaultDuration=""
            autoPlayAfterSrcChange={false}
            showJumpControls={false}
            onPlay={e => console.log("onPlay")}
            {...otherProps}
        />
    )
}
